const defaultEnvironments = {
  STG: {
    label: 'Staging',
    baseURL: 'https://stg.boston.basset.ws',
    dashboardURL: 'https://stg.bostonscripts.basset.la/bostonscripts/dashboard',
    apiKey: 'WrF13sw4H33aj58ZOknBl3PTmc9GQUK518VMir7I',
    enable2FA: true,
    enableDevReviewPolling: false,
    devReviewPollingIntervalMs: 90000,
  },
  PROD: {
    label: 'Produccion',
    baseURL: 'https://boston.basset.ws',
    dashboardURL: 'https://bostonscripts.basset.la/bostonscripts/dashboard',
    apiKey: 'zCoaKX2Q7q85ogSdguFeN5orP5LO3MbI6sJKQfee',
    enable2FA: true,
    enableDevReviewPolling: false,
    devReviewPollingIntervalMs: 90000,
  },
}

function envValue(name, fallback) {
  return process.env[name] || fallback
}

function envBool(name, fallback) {
  const raw = process.env[name]
  if (raw === undefined || raw === null || raw === '') return fallback
  const value = String(raw).trim().toLowerCase()
  if (['1', 'true', 'yes', 'on', 'enabled'].includes(value)) return true
  if (['0', 'false', 'no', 'off', 'disabled'].includes(value)) return false
  return fallback
}

export const environments = {
  STG: {
    ...defaultEnvironments.STG,
    baseURL: envValue('REACT_APP_STG_API_BASE_URL', defaultEnvironments.STG.baseURL),
    dashboardURL: envValue('REACT_APP_STG_DASHBOARD_URL', defaultEnvironments.STG.dashboardURL),
    apiKey: envValue('REACT_APP_STG_API_KEY', defaultEnvironments.STG.apiKey),
    enable2FA: envBool('REACT_APP_STG_ENABLE_2FA', false),
    enableDevReviewPolling: envBool('REACT_APP_STG_ENABLE_DEV_REVIEW_POLLING',false),// envBool('REACT_APP_ENABLE_DEV_REVIEW_POLLING', defaultEnvironments.STG.enableDevReviewPolling)),
    devReviewPollingIntervalMs: Number(envValue('REACT_APP_STG_DEV_REVIEW_POLLING_MS',90000)),// envValue('REACT_APP_DEV_REVIEW_POLLING_MS', defaultEnvironments.STG.devReviewPollingIntervalMs))),
    // enable2FA: envBool('REACT_APP_STG_ENABLE_2FA', envBool('REACT_APP_ENABLE_2FA', defaultEnvironments.STG.enable2FA)),
  },
  PROD: {
    ...defaultEnvironments.PROD,
    baseURL: envValue('REACT_APP_PROD_API_BASE_URL', defaultEnvironments.PROD.baseURL),
    dashboardURL: envValue('REACT_APP_PROD_DASHBOARD_URL', defaultEnvironments.PROD.dashboardURL),
    apiKey: envValue('REACT_APP_PROD_API_KEY', defaultEnvironments.PROD.apiKey),
    enable2FA: envBool('REACT_APP_PROD_ENABLE_2FA',true),
    enableDevReviewPolling: envBool('REACT_APP_PROD_ENABLE_DEV_REVIEW_POLLING',false ),//envBool('REACT_APP_ENABLE_DEV_REVIEW_POLLING', defaultEnvironments.PROD.enableDevReviewPolling)),
    devReviewPollingIntervalMs: Number(envValue('REACT_APP_PROD_DEV_REVIEW_POLLING_MS',90000 )),//envValue('REACT_APP_DEV_REVIEW_POLLING_MS', defaultEnvironments.PROD.devReviewPollingIntervalMs))),
    // enable2FA: envBool('REACT_APP_PROD_ENABLE_2FA', envBool('REACT_APP_ENABLE_2FA', defaultEnvironments.PROD.enable2FA)),
  },
}

export const LOGIN_BOOTSTRAP_TOKEN = 'A918793092830923002309812'
export const storageKey = 'boston_scripts_session'
export const TWO_FACTOR_ENABLED = envBool('REACT_APP_ENABLE_2FA', true)

function normalizeEnv(env) {
  const key = String(env || '').toUpperCase()
  return environments[key] ? key : ''
}

function envFromHost() {
  const host = window.location.hostname.toLowerCase()
  const subdomain = host.split('.')[0] || ''
  if (subdomain === 'stg') return 'STG'
  if (subdomain === 'stage') return 'STG'
  return ''
}

export function preferredEnv() {
  const params = new URLSearchParams(window.location.search)
  const fromQuery = normalizeEnv(params.get('env'))
  if (fromQuery) return fromQuery

  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey) || '{}')
    const fromSession = normalizeEnv(saved.env)
    if (fromSession) return fromSession
  } catch (_) {
    const fromBuild = normalizeEnv(process.env.REACT_APP_ENV_NAME)
    return fromBuild || 'PROD'
  }

  const fromHost = envFromHost()
  if (fromHost) return fromHost

  const fromBuild = normalizeEnv(process.env.REACT_APP_ENV_NAME)
  return fromBuild || 'PROD'
}

export function envConfig() {
  return environments[preferredEnv()] || environments.PROD
}

export function configForEnv(env) {
  return environments[normalizeEnv(env)] || envConfig()
}

export function twoFactorEnabled() {
  return envConfig().enable2FA !== false
}

export function devReviewPollingEnabled() {
  return envConfig().enableDevReviewPolling === true
}

export function devReviewPollingIntervalMs() {
  const value = Number(envConfig().devReviewPollingIntervalMs || 90000)
  return Number.isFinite(value) ? Math.max(90000, value) : 90000
}

export function dashboardEnvConfig() {
  return configForEnv(new URLSearchParams(window.location.search).get('env') || preferredEnv())
}
//test
export function dashboardBaseURL() {
  return `${window.location.origin}/v2/bostonscripts/dashboard`
}
